import { createLeafComponent as c, createContainerComponent as a, createDivOverlayComponent as i } from "./component.js";
import { createControlHook as l } from "./control.js";
import { createElementHook as r, createElementObject as p } from "./element.js";
import { createLayerHook as m } from "./layer.js";
import { createDivOverlayHook as f } from "./div-overlay.js";
import { createPathHook as C } from "./path.js";
function O(e) {
  function t(u, s) {
    return p(e(u), s);
  }
  const o = r(t), n = l(o);
  return c(n);
}
function h(e, t) {
  const o = r(e, t), n = m(o);
  return a(n);
}
function P(e, t) {
  const o = r(e), n = f(o, t);
  return i(n);
}
function D(e, t) {
  const o = r(e, t), n = C(o);
  return a(n);
}
function b(e, t) {
  const o = r(e, t), n = m(o);
  return c(n);
}
export {
  O as createControlComponent,
  h as createLayerComponent,
  P as createOverlayComponent,
  D as createPathComponent,
  b as createTileLayerComponent
};
